import { handleSettledPromises } from '@kk/shared/utils/async';
import { hasNoErrors } from '@kk/shared/utils/type-guards';
import { useParams, useRouteLoaderData } from 'react-router';
// import { fetchLoanPortfolioQuery } from '@/api/hooks/useLoanPortfolio';
import type { AnnualStatementsResponse } from '../TEMPORARY_TYPES';

export type LoaderData = Awaited<ReturnType<typeof loader>>;

export type Params = {
  companyId?: string;
};

export const id = 'annual-statements-page' as const;

async function loader() {
  // const companyId = '1';
  const data = await handleSettledPromises([
    // fetchLoanPortfolioQuery({ companyId }),
  ]);
  if (!hasNoErrors(data))
    throw new Error(`Failed to load annual statements for company ${id}`);

  const annualStatements: AnnualStatementsResponse = {
    fileAttachments: [],
  };

  return annualStatements;
}

export const useAnnualStatementsPageLoaderData = () =>
  useRouteLoaderData(id) as LoaderData;

export const useAnnualStatementsPageParams = () => useParams<Params>();

export default loader;
